export default {
  id: "yearOverYearTrend",
  name: "",
  description: "",
  report: {
    name: "Year over Year Trend",
    chartType: "BAR",
    template: "year-over-year-trend",
    config: {
      dataType: "single",
      dataSet: "SaleItem",
      dimensions: [],
      measures: [
        "SaleItem.rolling_month_revenue",
        "SaleItem.previous_year_revenue",
        "SaleItem.year_over_year_revenue_change",
      ],
      sort: {},
      timeGranularity: "month",
      applyDateRangeFilter: false,
      filterDateRange: false,
      filters: [],
      compare: false,
      limit: "12",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
